import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'productCategoryPaginate',
    serviceName: 'graphql',
    query: gql`
      query productCategoryPaginate(
        $ids: [String]
        $title: String
        $depth: Int
        $shop_id: String
        $for_admin: Int
        $category_id: String
        $shop_type_id: String
        $orderBy_field: String
        $walk_direction: String
        $selected_categories: Int
        $orderBy_direction: String
      ) {
        productCategoryPaginate(
          ids: $ids
          title: $title
          depth: $depth
          shop_id: $shop_id
          for_admin: $for_admin
          category_id: $category_id
          shop_type_id: $shop_type_id
          orderBy_field: $orderBy_field
          walk_direction: $walk_direction
          orderBy_direction: $orderBy_direction
          selected_categories: $selected_categories
        ) {
          total
          last_page
          data {
            id
            title
            parent {
              id
            }
            media {
              full_url
            }
            children {
              id
              title
              parent {
                title
              }
              media {
                full_url
              }
              children {
                id
              }
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteProductCategory',
    serviceName: 'admin',
    query: gql`
      mutation deleteProductCategory($ids: [String]!) {
        deleteProductCategory(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'productCategoryPaginate',
    serviceName: 'graphql',
    query: gql`
      query productCategoryPaginate($ids: [String]) {
        productCategoryPaginate(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'productCategoryPaginate',
    serviceName: 'graphql',
    query: gql`
      query productCategoryPaginate($ids: [String]) {
        productCategoryPaginate(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
